import React from 'react'

// general imports
import { IconPropsType } from '../types'

const CalendarIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      width='16'
      height='16'
      className={className}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M10.6667 1.33594V4.0026M5.33333 1.33594V4.0026M2 6.66927H14M3.33333 2.66927H12.6667C13.403 2.66927 14 3.26622 14 4.0026V13.3359C14 14.0723 13.403 14.6693 12.6667 14.6693H3.33333C2.59695 14.6693 2 14.0723 2 13.3359V4.0026C2 3.26622 2.59695 2.66927 3.33333 2.66927Z'
        stroke='#101828'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default CalendarIcon
